module.exports = _.each;